import React, {FC, ReactNode} from 'react';
import styled from 'styled-components';

import {Button} from '../../../libs/shared/ui/src/components/buttons/button';
import {fontSizes, fontWeights} from '../../../libs/shared/ui/src/styles/fontStyles';
import {addCardStyles} from '../../../libs/shared/ui/src/styles/mixins';

/*
 * Props.
 */

interface HelpTopicCardContent {
  illustration: string;
  title: ReactNode;
  description: ReactNode;
  actionLabel: ReactNode;
}

interface HelpTopicCardProps {
  className?: string;
  content: HelpTopicCardContent;
  onClick: () => void;
}

/*
 * Style.
 */

const StyledHelpCardDiv = styled.div`
  ${addCardStyles()}
  display: flex;
  height: 130px;
  overflow: hidden;
`;

const StyledImg = styled.img`
  flex: 1 1 50%;
  min-width: 80px;
  max-width: 125px;
  object-fit: cover;
`;

const StyledContentContainerDiv = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  padding: 16px;
`;

const StyledTitleSpan = styled.span`
  font-weight: ${fontWeights.bold};
  font-size: ${fontSizes.medium};
  line-height: 1.3;
  color: ${(p) => p.theme.greys.shade80};
`;

const StyledDescriptionParagraph = styled.div`
  font-weight: ${fontWeights.medium};
  font-size: ${fontSizes.verySmall};
  line-height: 150%;
  color: ${(p) => p.theme.greys.shade70};
  text-overflow: ellipsis;
  margin-top: 4px;
  height: 100%;
`;

const StyledButton = styled(Button)`
  width: fit-content;
  margin-top: 8px;
`;

/*
 * Component.
 */

export const HelpTopicCard: FC<HelpTopicCardProps> = (props) => {
  const {content, className, onClick} = props;
  const {illustration, title, description, actionLabel} = content;
  return (
    <StyledHelpCardDiv className={className}>
      <StyledImg src={illustration} alt="Live webinar illustration" />
      <StyledContentContainerDiv>
        <StyledTitleSpan>{title}</StyledTitleSpan>
        <StyledDescriptionParagraph>{description}</StyledDescriptionParagraph>
        <StyledButton onClick={onClick} rightIcon="externalLinkSmall">
          {actionLabel}
        </StyledButton>
      </StyledContentContainerDiv>
    </StyledHelpCardDiv>
  );
};
